import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 300px;
  border: 0.5px solid #eaf1f6;
  border-radius: 3px;
  padding: 14px;
  margin: 0;
  align-self: flex-start;
`;

export const Heading = styled.div`
  font-size: 18px;
  margin-bottom: 20px;
  color:black
`;

export const AddonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
